import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

declare const _: any;

@Injectable({
  providedIn: 'root'
})
export class F4626Service {
  constructor(private http: HttpClient) { }

  fetch4626Details(
    baseUrl: string,
    rowData: any,
    currentPart: string, 
    currentSchedule: string, 
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    // CRITICAL: F7004 SUCCESS PATTERN - Use application/x-www-form-urlencoded
    const params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Build params like original AngularJS service
    const requestParams = {
      ...params,
      action_code: 'q9i7om',
      tax_year: filterParams.tax_year || rowData.TAX_YEAR,
      scenario: filterParams.scenario || rowData.SCENARIO,
      jcd_key: rowData.JCD_KEY || 250,
      combination_key: rowData.COMBINATION_KEY,
      schedule_name: "N/A",
      part_no: currentPart,
      fg_key: filterParams.filing_key,
      group_type: '',
      form_name: "F4626",
      section_name: currentSchedule
    };

    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== null && requestParams[key] !== undefined) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(`${baseUrl}/loadJsonObject`, urlEncoded.toString(), httpOptions);
  }

  saveForm4626(
    baseUrl: string,
    finalData: any[],
    clobSettings: any, 
    currentPart: string, 
    currentSchedule: string, 
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // 🚀 CRITICAL: Build AngularJS-compatible payload structure with ALL required fields (Sch B pattern)
    const jsonSettings = {
      "tax_year": rowData.TAX_YEAR || filterParams.tax_year,
      "scenario": rowData.SCENARIO || filterParams.scenario || "",
      "jcd_key": rowData.JCD_KEY || filterParams.jcd_key || "",
      "combination_key": rowData.COMBINATION_KEY || filterParams.combination_key,
      "scenarioCode": rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || "",
      "is_issue_key_enabled": "N"
    };

    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(finalData) }, params);
    params = _.extend({ clob_settings: JSON.stringify(clobSettings) }, params);
    params.process_name = "Form 4626 Save";
    
    // Add F4626 specific params
    params.part_no = currentPart;
    params.schedule_name = "N/A";
    params.form_name = "F4626";
    params.section_name = currentSchedule;
    params.sso_id = globalService?.globalParams?.sso_id || "400412387";
    params.combination_key = rowData.COMBINATION_KEY || filterParams.combination_key;
    
    // Add required fields as separate parameters (like Sch B does)
    params.tax_year = rowData.TAX_YEAR || filterParams.tax_year;
    params.scenario = rowData.SCENARIO || filterParams.scenario || "";
    params.jcd_key = rowData.JCD_KEY || filterParams.jcd_key || "";
    params.scenarioCode = rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || "";
    params.is_issue_key_enabled = "N";

    // 🚀 CRITICAL: Build checkLockedbj from rowData matching AngularJS format (Sch B pattern)
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.SOURCE_LEID || "",
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || "1"),
      "combination_key": String(rowData.COMBINATION_KEY || filterParams.combination_key || "")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Add other required fields from rowData
    if (rowData.CONSOL_GROUP_KEY) {
      params.filing_key = rowData.CONSOL_GROUP_KEY;
    }

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(`${baseUrl}/saveJsonObject?action_code=yr77t9`, urlEncoded.toString(), httpOptions);
  }

  loadCountryList(baseUrl: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.get<any>(`${baseUrl}/loadJsonObject?action_code=kgdgoh`, httpOptions);
  }
}